import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=3d85ff0d&scoped=true"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=3d85ff0d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d85ff0d",
  null
  
)

export default component.exports